module.exports = __webpack_public_path__ + "static/media/outlook_grey_icon.98c9c5e1.png";